import ProductLoader from './product-loader.component'

export default ProductLoader